import $$trustFunding from 'models/pages/trust-funding';

import { type ColumnProps } from 'components/Table/Table';

import useResources from 'hooks/useResources';

import imgTrashCan from 'assets/icons/trash-can-grey.svg';

import { type TrustFundingAsset } from 'types/zod/trust-funding-asset';

const columns: (t: ReturnType<typeof useResources>['t']) => ColumnProps<TrustFundingAsset>[] = (t) => [
    {
        name: 'name',
        label: t('trustFunding.alreadyCreated.table.columns.name'),
    },
    {
        name: 'category',
        label: t('trustFunding.alreadyCreated.table.columns.category'),
        transform: ({ value: category }) => t(`trust_fund:${category}`),
    },
    {
        name: 'done',
        label: t('trustFunding.alreadyCreated.table.columns.done'),
        extra: 'width: 150px; flex: none; justify-content: center;',
        cell: {
            type: 'custom',
            customContent: ({ id, done }) => (
                <input
                    type="checkbox"
                    className="ignore-row-click"
                    checked={done}
                    onChange={() => $$trustFunding.doneAssetClicked(id)}
                />
            ),
        },
    },
    {
        name: 'action',
        label: t('trustFunding.alreadyCreated.table.columns.action'),
        extra: 'width: 50px; flex: none;',
        cell: {
            type: 'custom',
            extra: 'justify-content: center;',
            customContent: ({ id }) => (
                <button
                    className="btn btn-link p-0 min-w-none ignore-row-click"
                    type="button"
                    onClick={() => $$trustFunding.deleteAssetClicked(id)}
                >
                    <img alt="Trash can" src={imgTrashCan} />
                </button>
            ),
        },
    },
];

export default columns;
